// https://github.com/sid04naik/jquery.plugin-boilerplate
// The semi-colon before the function invocation is a safety net against concatenated scripts and/or other plugins which may not be closed properly.
// "undefined" is used because the undefined global variable in ECMAScript 3 is mutable. (ie. it can be changed by someone else). Because we don't pass a value to undefined when the anonymous function is invoked, we ensure that undefined is truly undefined.
// Note: In ECMAScript 5 undefined can no longer be modified.
// "window" and "document" are passed as local variables rather than global. This (slightly) quickens the resolution process and can be more efficiently minified (especially when both are regularly referenced in your plugin).
  (function ($, window, document, undefined) {
  // The purpose of "use strict" is to indicate that the code should be executed in "strict mode". With strict mode, you can not, for example, use undeclared variables.
  "use strict";

  // Store the name of the plugin in the "name" variable. This variable is used in the "Plugin" constructor below, as well as in the plugin wrapper to construct the key for the "$.data" method.
  // More: http://api.jquery.com/jquery.data/
  let self, pluginName = 'ares';

  //The "Plugin" constructor, builds a new instance of the plugin for the DOM node(s) that the plugin is called on.
  //For example, "$('selector').name();" creates a new instance of name for the given selector.
  function Plugin(element, options) {
    // Provide local access to the DOM node(s) that are called the plugin, as well local access to the ident and default options.
    self = this;
    self.element = element;
    self.ident = pluginName;
    self.defaults = $.fn[self.ident].defaults;
    // Support customization of the plugin on a per-element basis. For example, <div class=item' data-[plugin]-options='{"message":"Goodbye World!"}'></div>
    self.metadata = $(self.element).data(self.ident + '-options');
    // The "$.extend" method merges the contents of two or more objects, and stores the result in the first object. The first object is empty so that we don't alter the default options for future instances of the plugin.
    // More: http://api.jquery.com/jquery.extend/
    self.settings = $.extend({}, self.defaults, options, self.metadata);
    // The "init" method is the starting point for the plugin logic.
    // Calling the init method here in the "Plugin" constructor function allows us to store all methods (including the init method) in the plugin's prototype.
    self.init();
  }

  // Avoid Plugin.prototype conflicts
  $.extend(Plugin.prototype, {
    // Initialization logic
    init: function () {
      // Create additional methods below and call them via "self.myFunction(arg1, arg2)", ie: "self.build();".
      // Note: You can access the DOM node(s), ident, default plugin options and custom plugin options for a each instance of the plugin by using the variables "self.element", "self.ident", "self.defaults" and "self.settings" created in the "Plugin" constructor function
      // (as shown in the build method below).
      self.build();
      self.bindEvents();
      self.$spinner.hide();
      self.$selector.prop('disabled', !checkIco(self.$inputIco.val()));
    },
    // Remove plugin instance completely
    destroy: function () {
      // The destroy method unbinds all events for the specific instance of the plugin, then removes all plugin data that was stored in the plugin instance using jQuery's .removeData method.
      // Since we store data for each instance of the plugin in its instantiating element using the $.data method (as explained in the plugin wrapper below), we can call methods directly on the instance outside of the plugin initialization, ie: $('selector').data('plugin_myPluginName').someOtherFunction();
      // Consequently, the destroy method can be called using: $('selector').data('plugin_myPluginName').destroy();
      self.unbindEvents();
      self.$element.removeData();
    },
    // Cache DOM nodes for performance (_buildCache)
    build: function () {
      // Create variable(s) that can be accessed by other plugin functions. For example, "this.$element = $(this.element);" will cache a jQuery reference to the element that initialized the plugin.
      // Cached variables can then be used in other methods.
      self.$element = $(self.element);
      self.$selector = $('[data-' + self.ident + '-role="selector"]', self.$element);
      self.$spinner = $('[data-' + self.ident + '-role="spinner"]', self.$element);
      self.$inputIco = $(':input[data-' + self.ident + '-bind="ico"]', self.$element);
      self.$csrf = $('input[name="' + self.settings.CsrfKey + '"]', self.$element);
    },
    // Bind events that trigger methods
    bindEvents: function () {
      // Bind event(s) handlers that trigger other functions, ie: "plugin.$element.on('click', function() {});".
      // Note the use of the cached variable we created in the build method.
      // All events are namespaced, ie: ".on('click'+'.'+this.ident', function() {});".
      // This allows us to unbind plugin-specific events using the _unbindEvents method below.
      //plugin.$_element.on('click' + '.' + plugin.ident, function () {
      //  /*
      //    Use the "call" method to call the function. ie: "someOtherFunction", the "this" keyword refers to the plugin instance, not the event handler.
      //    More: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/call
      //  */
      //  plugin._someOtherFunction.call(plugin);
      //});
      self.$inputIco.on('input' + '.' + self.ident + ' keyup' + '.' + self.ident, function (_event) {
        self.$selector.prop('disabled', !checkIco(self.$inputIco.val()));
      });

      self.$selector.on('click' + '.' + self.ident, function (event) {
        //plugin.loader.call(plugin);
        loader(event);
      });
    },
    // Unbind events that trigger methods
    unbindEvents: function () {
      // Unbind all events in our plugin's namespace that are attached to "this.$element".
      //this.$element.off('.' + this._name);
      self.$inputIco.off('input' + '.' + self.ident + ' keyup' + '.' + self.ident);
      self.$selector.off('click' + '.' + self.ident);
    },
    // Callback methods
    callback: function () {
      // Cache onComplete option
      let onComplete = self.settings.onComplete;
      if (typeof onComplete === "function") {
        // Use the "call" method so that the onComplete callback function the "this" keyword refers to the specific DOM node that called the plugin.
        // More: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/call
        onComplete(self.element);
      }
    }
  });


  // Private methods
  var checkIco = function (ico) {
    try {
      var s = ('00000000' + ico).slice(-8);
      var a = 0;
      if (s.length !== 8) throw 1;
      var b = s.split('');
      var c = 0;
      for (var i = 0; i < 7; i++) a += parseInt(b[i]) * (8 - i);
      a = a % 11;
      c = 11 - a;
      if (a === 1) c = 0;
      if (a === 0) c = 1;
      if (a === 10) c = 1;
      if (parseInt(b[7]) !== c) throw (1);
    }
    catch (e) { return false; }
    return true;
  };

  var bindInput = function (name) {
    return $(':input[data-' + self.ident + '-bind="' + name + '"]', self.$element);
  };

  var bindRole = function (name) {
    return $('[data-' + self.ident + '-role="' + name + '"]', self.$element);
  };

  var loader = function (event) {
    event.target.disabled = true;
    var headersObj = {};
    headersObj[self.settings.CsrfKey] = self.$csrf.val();
    var ico = ("00000000" + self.$inputIco.val()).slice(-8); // nový ARES vyžaduje úvodní nuly
    $.ajax({
      url: self.settings.UrlBase + self.settings.UrlPath,
      data: "ico=" + ico,
//      headers: { [self.settings.CsrfKey]: self.$csrf.val() }, // platná syntaxe, ale minifikátor na tom zbuchne, tak vyřešeno jinak
      headers: headersObj,
      dataType: "json",
      type: "POST",
      beforeSend: function () {
        self.$spinner.show();
      },
      success: function (json) {
        self.$spinner.hide();
        if (json && json.ico) {
          const maxLen = "maxlength";
          var ctrl = bindInput("organizace");
          ctrl.val((json.obchodniJmeno || "").substring(0, ctrl.attr(maxLen)));

          var sUlice = json.sidlo.nazevUlice || json.sidlo.nazevCastiObce;
          ctrl = bindInput("ulice");
          ctrl.val(sUlice.substring(0, ctrl.attr(maxLen)));

          var sCislo = json.sidlo.cisloDomovni || "";
          bindInput("cdom").val(sCislo);
          var sOrientacni = json.sidlo.cisloOrientacni || "";
          bindInput("cor").val(sOrientacni);
          if (sOrientacni !== "") sCislo = sCislo + "/" + sOrientacni;
          bindInput("cdomor").val(sCislo);

          var sObec = json.sidlo.nazevMestskehoObvodu || json.sidlo.nazevObce;
          ctrl = bindInput("obec");
          ctrl.val(sObec.substring(0, ctrl.attr(maxLen)));

          bindInput("psc").val(json.sidlo.psc || "");
          var sDic = json.dicSkDph || json.dic || "";
          if ((sDic != "") && (sDic.substr(0, 2).toUpperCase() != "CZ")) sDic = "CZ" + sDic;
          bindInput("dic").val(sDic);
          bindRole("focus").focus();
        }
        else {
          self.$inputIco.focus();
          alert("Subjekt nenalezen.");
        }
      },
      error: function (_jqXHR, textStatus, errorThrown) {
        self.$spinner.hide();
        if (textStatus !== "abort") {
          var sError = textStatus + ": " + errorThrown;
          if (errorThrown === "Too Many Requests") { sError = "překročen povolený počet dotazů"; }
          alert("Chyba při načítání dat z ARES (" + sError + ").");
        }
      },
      complete: function () {
        event.target.disabled = !checkIco(self.$inputIco.val());
      }
    });
  };

  // Create a lightweight plugin wrapper around the "Plugin" constructor, preventing against multiple instantiations.
  // More: http://learn.jquery.com/plugins/basic-plugin-creation/
  $.fn[pluginName] = function (options) {
    this.each(function () {
      let key = "plugin_" + pluginName;
      if (!$.data(this, key)) {
        // Use "$.data" to save each instance of the plugin in case the user wants to modify it.
        // Using "$.data" in this way ensures the data is removed when the DOM element(s) are removed via jQuery methods, as well as when the user leaves the page.
        // It's a smart way to prevent memory leaks. More: http://api.jquery.com/jquery.data/
        $.data(this, key, new Plugin(this, options));
      }
    });
    // returns the original jQuery object. This allows additional jQuery methods to be chained.
    return this;
  };

  // Attach the default plugin options directly to the plugin object. This allows users to override default plugin options globally, instead of passing the same option(s) every time the plugin is initialized.
  // For example, the user could set the "property" value once for all instances of the plugin with
  // "$.fn.name.defaults.property = 'myValue';". Then, every time plugin is initialized, "property" will be set to "myValue".
  // More: http://learn.jquery.com/plugins/advanced-plugin-concepts/
  $.fn[pluginName].defaults = {
    CsrfKey: 'RequestVerificationToken',
    UrlPath: '/share/ares.asp'
  };

  $('form[data-ares-options]').ares();

}(jQuery, window, document));